import { ChildtabsPage } from '../pages/childtabs/childtabs';
import { TabPage } from '../pages/tabpage/tabpage';

export const SEARCHTYPE_CATEGORY = 4;
export const SEARCHTYPE_ALLDEALS = 2;
export const SEARCHTYPE_KEYWORD = 8;

export const RECOMMENDED = { title: 'Recommended', id: 'parent1', root: ChildtabsPage, params: { tabid: '1', name: 'RECOMMENDED' } };
export const LOCAL = { title: 'Local', id: 'parent2', root: ChildtabsPage, params: { tabid: '2', name: 'LOCAL' } };
export const ONLINE = { title: 'Online', id: 'parent3', root: ChildtabsPage, params: { tabid: '3', name: 'ONLINE' } };
export const VACATIONS = { title: 'Vacations', id: 'parent4', root: ChildtabsPage, params: { tabid: '4', name: 'VACATIONS' } };
export const FEATURED = { title: 'Featured', id: 'parent5', root: ChildtabsPage, params: { tabid: '5', name: 'FEATURED' } };
export const FAVORITES = { title: 'Favorites', id: 'parent6', root: TabPage, params: { tabid: '6', name: 'FAVORITES', 'SearchTypeName': 'FAVORITES', 'SearchTypeID': '6', 'Keyword': '', 'ScreenTitle': 'FAVORITES' } };
export const AAA_DOLLARS = { title: 'AAA Dollars', id: 'parent7', root: TabPage, params: { tabid: '7', name: 'AAA_DOLLARS', 'SearchTypeName': 'AAA Dollars', 'SearchTypeID': '1', 'Keyword': '', 'ScreenTitle': 'AAA+Dollars', 'AAADollarsFlag': 'true' } };

export const HEADER_API_KEY = 'x-api-key';

export const browsing_history = 'Browsing History';
export const cruise_vacations = 'Cruise Vacations';
export const tour_vacations = 'Tour Vacations';
export const attractions_and_events = 'Attractions and Events';
export const most_popular = 'Most Popular';
export const internetAlertTitle = 'Sorry!';
export const internetAlertMessage = 'The Internet connection appears to be offline';
export const alertPositiveButtonTitle = 'OK';
